module.exports = __webpack_public_path__ + "static/media/charge-affiliate.bb979c97.png";